<template>
  <div class="multipane-resizer"><slot></slot></div>
</template>

<script>
export default {
  name: 'AppMultipaneResizer',
}
</script>

<style scoped>

.multipane-resizer {
  margin: 0; left: 0;
  position: relative;
  height: 300px;

  &:before {
    display: block;
    content: "";
    width: 3px;
    height: 40px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -20px;
    margin-left: -1.5px;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
  }

  &:hover {
    &:before {
      border-color: #999;
    }
  }
}
</style>